import { selectAll } from 'd3-selection'

export const hideLoader = () => {
  selectAll('.loader')
    .style('visibility', 'hidden')
  selectAll('.loader-dark')
    .style('visibility', 'hidden')
}

export const showLoader = () => {
  selectAll('.loader')
    .style('visibility', 'visible')
  selectAll('.loader-dark')
    .style('visibility', 'visible')
}